import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { IPagingOptions } from '@/coreDomainsModule/paging';
import { TableType } from '@/coreDomainsModule/table';
import { SortType } from '@/coreInfrastructureModule/axios/generated/inventoryManage';
import { LoadingStatus } from '@/corePagesModule/components/ezTable/types';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';

/**
 * EzTableのヘッダー情報ベース定義
 */
type EditBusinessHeaderOptionBase = {
  key: string;
  label: string;
};

/**
 * EzTableのヘッダー情報定義
 */
export type EditBusinessHeaderOption = EditBusinessHeaderOptionBase &
  (
    | {
        type: 'uni';
        width: number;
      }
    | {
        type: 'str' | 'num' | 'date';
        width?: number;
      }
  );

/**
 * 表示する取引タイプ
 */
export type EditBusinessMode = 'aggregateBusiness' | 'baseBusiness';

/**
 * 取引モード別コンフィグ
 */
export type EditBusinessModeConfig = { headerOptions: EditBusinessHeaderOption[]; tableType: { bulk: TableType; master: TableType } };

/**
 * 取引編集State定義
 */
export interface IBulkEditBusinessState {
  businessMode: EditBusinessMode;
  loadingStatus: LoadingStatus;
  pagingOptions: IPagingOptions;
  sortInfo: { key: string; type: SortType };
  filterItems: FilterContentItem[];
  dataList: IBusiness[];
  checkedIds: Set<string>;
  editDropdownState: boolean;
}

/**
 * a
 */
export type EditMasterItem = { code: string; name: string };

/**
 * a
 */
export const initMasterItem = (): EditMasterItem => ({ code: '', name: '' });
